// src/app/pages/dashboard/dashboard.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { DASHBOARD_API_DEFS } from '../../services/account-api.constants';
import { AjaxService } from '../../services/ajax.service';

import { ViewScopeService, Customer } from '../../services/view-scope.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private ajaxService: AjaxService,
    private viewScopeService: ViewScopeService
  ) { }

  getDashboardApiPathSegmentByName(name: string): string | undefined {
    return DASHBOARD_API_DEFS.find(item => item.name === name)?.pathSegment;
  }

  // Waits for ViewScopeService's selectedCustomer$ (a BehaviorSubject, always replays its
  // latest value) instead of reading localStorage synchronously - avoids racing
  // SelectAccountComponent, which populates the selected customer asynchronously right after
  // login, on the same tick the dashboard widgets mount.
  getExtendedData(caller: string): Observable<Record<string, any[]>> {
    const apiSegment = this.ajaxService.getBaseOfApi() + '/api/' + this.getDashboardApiPathSegmentByName(caller);
    const userId = this.viewScopeService.getCurrentOpertaingUserId();

    if (!apiSegment || !userId) {
      throw new Error('Missing required URL parameters.');
    }

    return this.viewScopeService.selectedCustomer$.pipe(
      filter((customer): customer is Customer => customer != null),
      take(1),
      switchMap(customer => {
        const apiUrl = `${apiSegment}${customer.id}/${userId}`;
        return this.ajaxService.getData(apiUrl) as Observable<Record<string, any[]>>;
      })
    );
  }
}
